export default class InputSearch {

	static selector = 'input-search';

	// class variables

	el = {};

	// constructor

	constructor(container) {
		this.el = {
			container,
			ctaClear: container.querySelector(`.${this.constructor.selector}__cta-clear`),
			input: container.querySelector(`.${this.constructor.selector}__input`)
		};

		this.initialize();
	}

	// initialize

	initialize() {
		this.#addEventListeners();
	}

	// add and remove listeners

	#addEventListeners = () => {
		this.el.ctaClear.addEventListener('click', this.#onCtaClearClick);
	}

	#removeEventListeners = () => {
		this.el.ctaClear.removeEventListener('click', this.#onCtaClearClick);
	}

	// listener methods

	#onCtaClearClick = (e) => {
		e.preventDefault();
		this.el.input.value = '';
	}

	// destroy

	destroy() {
		this.#removeEventListeners();
	}

}
